

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
  PointElement,
  LineElement,
  LineController,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { ChartDataset } from "./models";
import { externalTooltipHandler } from "./elements/tooltip2";
import { htmlLegendPlugin } from "./elements/legend";
import { DeviceConfiguration } from "models/devices/configuration";
import { t } from "i18next";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
  PointElement,
  LineElement,
  LineController
);

const BarGraph = (props: {
  id?: string;
  data: ChartDataset;
  config?: DeviceConfiguration;
  stacked?: boolean;
  extra?: string;
  height?: number;
}) => {
  const { id, data, config, stacked, extra, height } = props;

  const options = {
    indexAxis: "x" as const,
    responsive: true,
    maintainAspectRatio: false,
    config: config,
    elements: {
      bar: {
        borderWidth: 1,
      },
    },
    plugins: {
      legend: {
        display: false,
        position: "top" as const,
      },
      title: {
        display: false,
        text: "",
      },
      tooltip: {
        enabled: false,
        position: "nearest" as const,
        external: externalTooltipHandler,
      },
      htmlLegend: {
        containerID: "legend-container",
      },
    },

    scales: {
      x: {
        stacked: stacked,
        beginAtZero: true,
        max: 31,
        grid: {
          color: "transparent",
        },
      },
      y: {
        weight: 10,
        border: {
          display: false,
          dash: [5, 5],
        },
        grid: {
          drawBorder: false,
          color: "#cccccc",
        },
        ticks: {
          callback: function (value: number | string) {
            return `${value} ${t("device.units", {
              context: config.units,
            })}`;
          },
          maxTicksLimit: 5,
        },
      },
    },
  };

  return (
    <div className="w-full" style={{height: height - 150}}>
    <div id="legend-container" className="mb-2" />
      <Bar
        id={id}
        options={options}
        data={data}
        plugins={[htmlLegendPlugin]}
        className={`w-full ${extra}`}
      />
    </div>
  );
};

export default BarGraph;
